import type { ReactNode } from 'react'

import { cn } from '@/utils'
import {
  LABEL_COLUMN,
  LABEL_STAYS,
  LANE,
  LANE_PADDING,
  LANE_ROW,
  MEMBERS_FOLLOW,
  TIMELINE_COLUMN,
} from './mapLayout'

interface LaneFrameProps {
  label: ReactNode
  timeline: ReactNode
  labelStays: boolean
  // Member cards, drawn under the lane inside the same section.
  children?: ReactNode
}

export const LaneFrame = ({
  label,
  timeline,
  labelStays,
  children,
}: LaneFrameProps) => (
  <section className={LANE}>
    <div className={LANE_ROW}>
      <div
        className={cn(LABEL_COLUMN, LANE_PADDING, children && MEMBERS_FOLLOW)}
      >
        <div className={cn('bg-inherit pb-2', labelStays && LABEL_STAYS)}>
          {label}
        </div>
      </div>

      <div
        className={cn(
          TIMELINE_COLUMN,
          LANE_PADDING,
          children && MEMBERS_FOLLOW,
        )}
      >
        {timeline}
      </div>
    </div>
    {children}
  </section>
)
